<template>
  <footer>
    <div class="line">Powered by Dike International Co., Limited</div>
    <div style="margin-top: 5px">
      <span class="line">© Oasisdream</span>
      <span class="underline">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
      <span class="underline" @click="openModal(0)">Return</span>
      <span class="underline">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
      <span class="underline" @click="openModal(1)">Legal</span>
    </div>
    <custom-modal :visible="showModal" @cancel="hideModal">
      <div class="content">
        <a href="/LawArticle" target="_blank">
          <div class="title">Oasisdream Community Guidelines and Terms of Use</div>
        </a>
        <p>Hello! Welcome to Oasisdream's Community Guidelines and Terms o Hello! Welcome to Oasisdream's Community
          Guidelines and Terms of Use. Please read this carefully before using our website, services and products. This
          is a joint agreement between you and Oasisdream regarding platform services and other related matters.</p>
        <h3>1. Confirmation and acceptance of the agreement</h3>
        <p>By using or accessing the Oasisdream website or any other website owned by Oasisdream (as defined below) or
          any successor to the foregoing website (collectively, the "Site"), you ("you") acknowledge that you have read,
          understood and agree to these Terms of Use. Please be sure to read carefully and fully understand the contents
          of each clause, especially the clauses exempting or limiting liability, legal application and dispute
          resolution clauses. These Terms of Use constitute a binding agreement between you and Oasisdream. You are
          authorized to use the Site only if you agree to abide by these Terms of Use and all applicable laws. Please
          read these Terms of Use carefully. During the process of reading this Agreement, if you do not agree with this
          Agreement or any of its terms, you should immediately stop the registration process and stop using the
          services.</p>
        <h3>2. Additional terms</h3>
        <p>In addition to these Terms of Use, the following additional terIn addition to these Terms of Use, the
          following additional terms and policies (the "Additional Policies") govern the rights and responsibilities of
          Artists, Visitors, and all users of the Site:<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;A. The Artist Store Policy is an agreement between Oasisdream and artists or designers
          who open artist stores on the website to offer and publish products featuring their own artwork.<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;B. Buyer Rules stipulate the rights and obligations of users who visit this website to
          browse or shop. All such additional policies are incorporated into and made a part of these Terms of Use.
        </p>
        <h3>3. Grant of rights</h3>
        <p>Oasisdream hereby grants you a license to use the Site as set forth in these Terms of Use, provided
          that:<br/>
          (i) You may not reproduce or distribute any part of the Site in any medium without the prior written
          authorization of Oasisdream;<br/>
          (ii) you may not change or modify any part of the Site except as reasonably necessary to achieve its intended
          purpose;<br/>
          (iii) you will comply with the terms and conditions of these Terms of Use.</p>
        <h3>4. Your Account and Account Activity</h3>
        <p>You confirm that when you complete the registration process or actually use the service in other permitted
          ways, you should have the legal capacity for civil conduct that is appropriate for your behavior. If you do
          not have the aforementioned civil capacity appropriate to your behavior, you and your guardian shall bear the
          corresponding consequences in accordance with legal provisions and have the right to terminate the provision
          of services to you and cancel your account. If you register on the Oasisdream platform on behalf of a company
          or other legal subject, you represent and warrant that you have the right to bind the company or legal subject
          to this Agreement.<br/>
          After you fill in the information as prompted on the registration page, read and click to agree to this
          agreement, and complete the entire registration process, or when you actually use Oasisdream's services in
          other permitted ways, you will be bound by this agreement and its supplementary agreements.</p>
        <h3>5. Use of your account information</h3>
        <p>You acknowledge and agree that Oasisdream may preserve your account information and may disclose user
          information if required to do so by law or if we believe in good faith that such preservation or disclosure is
          reasonably necessary to: (i) comply with legal process; ii) enforce these Terms of Use; (iii) respond to legal
          claims; (iv) protect the rights, property or personal safety of Oasisdream, its users or the public.</p>
        <h3>6. Linked websites</h3>
        <p>This website may contain links to third party websites that are not owned or controlled by Oasisdream
          ("Linked Sites"). These links are provided as a convenience only and may not be kept current or maintained.
          Oasisdream does not screen linked sites and has no control over, and assumes no responsibility for, the
          content, quality, suitability, functionality, legality, privacy policies or practices of linked sites. You
          acknowledge and agree that Oasisdream is not responsible for the content or privacy practices of linked
          websites and it is your responsibility to review the policies of such websites before visiting them. If you
          access linked sites, you do so at your own risk. By using the Site, you expressly release Oasisdream from any
          liability arising out of your access to or use of any Linked Site, and your communications or transactions
          with other users, advertisers, partners or other third parties found on or through the Linked Site.
          responsibility. In addition, you also release Oasisdream from any liability arising from your participation in
          promotions, sweepstakes, events or any other activities sponsored, endorsed or sponsored by other users,
          advertisers, partners or other third parties outside of this website.</p>
      </div>
    </custom-modal>
  </footer>
</template>
<script>
import CustomModal from './CustomModal.vue'

export default {
  components: {
    CustomModal
  },
  data () {
    return {
      showModal: false,
    }
  },
  methods: {
    hideModal () {
      this.showModal = false
    },
    openModal (type) {
      if (type === 0) {
        window.open('/returns', '_blank')
      } else {
        window.open('/legal', '_blank')
      }
      // this.showModal = true
    },
  }
}
</script>
<style scoped lang="less">

footer {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.line {
  position: relative;
  font-weight: 400;
  font-size: 16px;
  color: #4C8EFF;
}

.underline {
  text-decoration: none;
  position: relative;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
  color: #4C8EFF;
}

.underline::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 1px;
  background-color: transparent;
  transition: background-color 0.3s ease;
}

.underline:hover::after {
  background-color: #4C8EFF;
}

.content {
  margin-top: 15px;
  margin-right: 20px;

  .title {
    text-align: center;
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 36px;
    color: #333333;
  }

  a {
    text-decoration: none;
    color: #333333;
  }


  a:hover {
    text-decoration: underline;
  }

  h3 {
    font-weight: bold;
    font-size: 20px;
    color: #333333;
  }

  p {
    font-weight: 500;
    font-size: 15px;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue